import { render } from "./PopupChonLichSuChuyenDi.vue?vue&type=template&id=5d7f4f81&scoped=true"
import script from "./PopupChonLichSuChuyenDi.vue?vue&type=script&lang=js"
export * from "./PopupChonLichSuChuyenDi.vue?vue&type=script&lang=js"

import "./PopupChonLichSuChuyenDi.vue?vue&type=style&index=0&id=5d7f4f81&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d7f4f81"]])

export default __exports__